import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Otp1 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mobile, uotp, name, email } = location.state || {};
  
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (value, index) => {
    if (value && !/^\d+$/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      const otpArray = pasteData.split('');
      setOtp(otpArray);
      inputRefs.current[5]?.focus();
    }
  };

  const verifyOTP = async () => {
    const otpCode = otp.join("");
    
    if (otpCode.length !== 6) {
      alert("Please enter a complete 6-digit OTP.");
      return;
    }
    
    if (otpCode != uotp) {
      alert("The OTP you entered is incorrect.");
      return;
    }

    setLoading(true);
    
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('name', name);
      formData.append('email', email);

      const response = await fetch("https://easycomm.in/Rest3/web_otp_verify_api2", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        navigate("/upload-docs/"+data.lid);
        
      } else {
        throw new Error(data.message || "Verification failed");
      }
      
    } catch (error) {
      alert(error.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!mobile) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center">
          <div className="spinner-border text-success mb-3"></div>
          <p>Invalid OTP session. Please try again.</p>
          <button className="btn btn-success" onClick={() => navigate('/register')}>
            Go to Register
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-light position-relative">
      {/* Background */}
      
      <div className="container h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 col-md-6 col-lg-5">
            <div className="card border-0 shadow-lg">
              <div className="card-body p-4 p-md-5">
                {/* Header */}
                <div className="text-center mb-4">
                  <div className="d-inline-block p-3 rounded-circle bg-success bg-opacity-10 mb-3">
                    <i className="bi bi-shield-check text-success fs-1"></i>
                  </div>
                  <h4 className="fw-bold text-dark mb-2">OTP Verification</h4>
                  <p className="text-muted">
                    Enter the 6-digit code sent to<br />
                    <span className="fw-semibold text-dark">{mobile}</span>
                  </p>
                </div>

                {/* OTP Input */}
                <div className="mb-4">
                  <label className="form-label fw-semibold text-secondary mb-3 d-block text-center">
                    6-Digit Verification Code
                  </label>
                  <div 
                    className="d-flex justify-content-center gap-2 mb-3"
                    onPaste={handlePaste}
                  >
                    {Array.from({ length: 6 }).map((_, index) => (
                      <input
                        key={index}
                        ref={el => inputRefs.current[index] = el}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        className="form-control form-control-lg text-center fw-bold border-2"
                        style={{
                          width: '55px',
                          height: '55px',
                          fontSize: '1.5rem',
                          borderColor: otp[index] ? '#0cba6b' : '#dee2e6',
                          backgroundColor: otp[index] ? '#f0fff8' : '#fff',
                        }}
                        value={otp[index]}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        autoComplete="one-time-code"
                      />
                    ))}
                  </div>
                  
                  {/* {otp.join("").length === 6 && otp.join("") !== uotp && (
                    <div className="text-center mt-2">
                      <small className="text-danger">
                        <i className="bi bi-exclamation-circle me-1"></i>
                        OTP doesn't match. Please try again.
                      </small>
                    </div>
                  )} */}
                </div>

                {/* Verify Button */}
                <button
                  className="btn btn-success btn-lg w-100 py-3 fw-bold mb-3"
                  onClick={verifyOTP}
                  disabled={loading || otp.join("").length !== 6}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Verifying...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      Verify & Continue
                    </>
                  )}
                </button>

                {/* Footer Links */}
                <div className="text-center">
                  <p className="text-muted small mb-2">
                    Didn't receive code?{" "}
                    <button 
                      className="btn btn-link p-0 text-success text-decoration-none"
                      onClick={() => alert('Resend OTP functionality here')}
                    >
                      Resend OTP
                    </button>
                  </p>
                  <button
                    className="btn btn-link text-decoration-none text-secondary"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-arrow-left me-1"></i> Back to previous
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Otp1;